import axios from "axios";
import JSZip from "jszip";
import FileSaver from "file-saver";

export function getFile(url) {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url,
      responseType: "arraybuffer",
	  headers: {
		  "Cache-Control": "no-cache"
	  }
	  // 禁用快取，防止瀏覽器不給"Origin"
    })
      .then((data) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error.toString());
      });
  });
}

export function downloadFile(data, filename = "download") {
  //   const data = ["各類地址1", "各類地址2"]; // 需要下載打包的路徑, 可以是本地相對路徑, 也可以是跨域的全路徑
  const zip = new JSZip();
  const cache = {};
  const promises = [];
  let name = "";
  data.forEach((item) => {
    const promise = getFile(item).then((data) => {
      // 下載文件, 並存成ArrayBuffer對像
      // const arr_name = item.split("/");
      // const file_name = arr_name[arr_name.length - 1]; // 獲取文件名
      let deal_file_name = item.slice(item.lastIndexOf("/") + 1).split(".");
      deal_file_name[0] = filename;
      const file_name = deal_file_name.join(".");

      name = filename;
      zip.file(file_name, data, { binary: true }); // 逐個添加文件
      cache[file_name] = data;
    });
    promises.push(promise);
  });

  Promise.all(promises).then(() => {
    zip.generateAsync({ type: "blob" }).then((content) => {
      // 生成二進制流
      FileSaver.saveAs(content, `${name}.zip`); // 利用file-saver保存文件
    });
  });
}

export function downloadFile1(data, filename) {
  //   const data = ["各類地址1", "各類地址2"]; // 需要下載打包的路徑, 可以是本地相對路徑, 也可以是跨域的全路徑
  const zip = new JSZip();
  const cache = {};
  const promises = [];
  let name = filename;
  data.forEach((item) => {
    const promise = getFile(item.scenes).then((data) => {
      // 下載文件, 並存成ArrayBuffer對像
      let deal_file_name = item.scenes.slice(item.scenes.lastIndexOf("/") + 1).split(".");
      const file_name = item.scenesname + '.' + deal_file_name[deal_file_name.length-1];

      zip.file(file_name, data, { binary: true }); // 逐個添加文件
      cache[file_name] = data;
    });
    promises.push(promise);
  });

  Promise.all(promises).then(() => {
    zip.generateAsync({ type: "blob" }).then((content) => {
      // 生成二進制流
      FileSaver.saveAs(content, `${name}.zip`); // 利用file-saver保存文件
    });
  });
}
